import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import { Input } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  //other part of the code//
  paper: {
    background: "var(--white)",
    color: "black",
  },
}));

export default function SelectCurrency(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  return (
    <FormControl>
      <Select
        readOnly={props.readOnly}
        disabled={props.readOnly}
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        disableUnderline={props.disableUnderline}
        style={{ fontSize: 16, paddingRight: "24px" }}
        value={value}
        displayEmpty
        className="currency-select"
        MenuProps={{
          classes: { paper: props.theme == "dark" ? classes.paper : {} },
        }}
        input={<Input />}
        inputProps={{ style: { fontSize: 16 } }}
        onChange={(e) => handleChange(e.target.value)}
      >
        <MenuItem value="" disabled>
          <InputLabel style={{ margin: 0, color: "#AAAAB4" }}>
            {" "}
            Currency
          </InputLabel>
        </MenuItem>

        <MenuItem value="AED">United Arab Emirates dirham - AED</MenuItem>
        <MenuItem value="AMD">Armenian dram - AMD</MenuItem>
        <MenuItem value="AUD">Australian dollar - AUD</MenuItem>
        <MenuItem value="BHD">Bahraini dinar - BHD</MenuItem>
        <MenuItem value="BRL">Brazilian real - BRL</MenuItem>
        <MenuItem value="BYN">Belarussian ruble - BYN</MenuItem>
        <MenuItem value="CAD">Canadian dollar - CAD</MenuItem>
        <MenuItem value="CHF">Swiss franc - CHF</MenuItem>
        <MenuItem value="CLP">Chilean peso - CLP</MenuItem>
        <MenuItem value="CNY">Chinese yuan renminbi - CNY</MenuItem>
        <MenuItem value="CZK">Czech koruna - CZK</MenuItem>
        <MenuItem value="DKK">Danish krone - DKK</MenuItem>
        <MenuItem value="EUR">Euro - EUR</MenuItem>
        <MenuItem value="GBP">British pound sterling - GBP</MenuItem>
        <MenuItem value="HKD">Hong Kong dollar - HKD</MenuItem>
        <MenuItem value="HUF">Hungarian forint - HUF</MenuItem>
        <MenuItem value="IDR">Indonesian rupiah - IDR</MenuItem>
        <MenuItem value="ILS">Israeli sheqel - ILS</MenuItem>
        <MenuItem value="INR">Indian rupee - INR</MenuItem>
        <MenuItem value="ISK">Icelandic krona - ISK</MenuItem>
        <MenuItem value="JOD">Jordanian dinar - JOD</MenuItem>
        <MenuItem value="JPY">Japanese yen - JPY</MenuItem>
        <MenuItem value="KGS">Kyrgyzstani som - KGS</MenuItem>
        <MenuItem value="KRW">South Korean won - KRW</MenuItem>
        <MenuItem value="KWD">Kuwaiti dinar - KWD</MenuItem>
        <MenuItem value="KZT">Kazakhstani tenge - KZT</MenuItem>
        <MenuItem value="MXN">Mexican peso - MXN</MenuItem>
        <MenuItem value="MYR">Malaysian ringgit - MYR</MenuItem>
        <MenuItem value="NOK">Norwegian krone - NOK</MenuItem>
        <MenuItem value="NZD">New Zealand dollar - NZD</MenuItem>
        <MenuItem value="OMR">Omani rial - OMR</MenuItem>
        <MenuItem value="PEN">Peruvian nuevo sol - PEN</MenuItem>
        <MenuItem value="PHP">Philippine peso - PHP</MenuItem>
        <MenuItem value="PLN">Polish zloty - PLN</MenuItem>
        <MenuItem value="QAR">Qatari rial - QAR</MenuItem>
        <MenuItem value="RON">Romanian leu - RON</MenuItem>
        <MenuItem value="RSD">Serbian dinar - RSD</MenuItem>
        <MenuItem value="RUB">Russian ruble - RUB</MenuItem>
        <MenuItem value="SAR">Saudi Arabian riyal - SAR</MenuItem>
        <MenuItem value="SEK">Swedish krona - SEK</MenuItem>
        <MenuItem value="SGD">Singapore dollar - SGD</MenuItem>
        <MenuItem value="THB">Thai baht - THB</MenuItem>
        <MenuItem value="TRY">Turkish lira - TRY</MenuItem>
        <MenuItem value="TWD">Taiwan dollar - TWD</MenuItem>
        <MenuItem value="UAH">Ukrainian hryvnia - UAH</MenuItem>
        <MenuItem value="USD">United States dollar - USD</MenuItem>
        <MenuItem value="UZS">Uzbekistan som - UZS</MenuItem>
        <MenuItem value="YER">Yemeni rial - YER</MenuItem>
        <MenuItem value="ZAR">South African rand - ZAR</MenuItem>
      </Select>
    </FormControl>
  );
}
SelectCurrency.defaultProps = {
  theme: "dark",
  fullWidth: false,
  disableUnderline: true,
  readOnly: false,
};
